module.exports = __webpack_public_path__ + "static/img/nx.752475d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/nx.png
// module id = TQDl
// module chunks = 0